import { combineReducers } from 'redux';

import { ACTIONS } from '../../../constants';
import { requestSuccessManagerSlice } from '../../pages/RequestSuccessManagerForm/redux/slice';
import { attachesSlice } from './attaches';
import { biEngagementSlice } from './biEngagement';
import { chatSlice } from './chat';
import { fieldSlice } from './field';
import { createState } from './fieldCreaters';
import { headerSlice } from './header';
import { helpCenterSlice } from './helpCenter';
import { homepageSlice } from './homepage';
import { inputsFocusReducer } from './inputsFocus';
import { metaReducer } from './meta';
import { modalReducer } from './modal';
import { solutionsSlice } from './solutions';
import { TActions } from './types';
import { userSlice } from './user';
import { widgetSlice } from './widget';
import { widgetSessionSlice } from './widgetSession';

const combinedReducers = combineReducers({
  chat: chatSlice.reducer,
  field: fieldSlice.reducer,
  header: headerSlice.reducer,
  user: userSlice.reducer,
  attaches: attachesSlice.reducer,
  modal: modalReducer,
  meta: metaReducer,
  inputsFocus: inputsFocusReducer,
  widgetSession: widgetSessionSlice.reducer,
  widget: widgetSlice.reducer,
  helpCenter: helpCenterSlice.reducer,
  solutions: solutionsSlice.reducer,
  homepage: homepageSlice.reducer,
  biEngagement: biEngagementSlice.reducer,
  requestSuccessManager: requestSuccessManagerSlice.reducer,
});

export type TRootState = ReturnType<typeof combinedReducers>;

export const rootReducer = (state: TRootState, action: TActions) => {
  if (action.type === ACTIONS.RESET_CHATBOT_STATE) {
    const initialChatbotState = {
      ...action.initialChatbotState,
      ...(action.initialChatbotState.field && {
        field: createState(action.initialChatbotState.field),
      }),
    };

    state = {
      ...state,
      ...(initialChatbotState as Partial<TRootState>),
      ...{ meta: { ...state.meta, ...initialChatbotState.meta } },
    };
  }

  return combinedReducers(state, action);
};
